exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "h1[data-v-9aea68b8]{font-size:var(--read-font-size-l)}", ""]);
